module.exports = __webpack_public_path__ + "img/logo0506.c0367766.png";